import React from "react";
import { Link } from "react-router-dom";
import { ScanSearch, Cpu, Calculator, ArrowRight } from "lucide-react";

const ITEMS = [
  { icon: ScanSearch, title: "3 portals", body: "Zillow, Redfin & Homes.com benchmarked against live comps." },
  { icon: Cpu, title: "3 AI appraisers", body: "Gemini, OpenAI & Claude each weigh the same local sales." },
  { icon: Calculator, title: "Your net equity", body: "Transfer taxes & a 1% fee vs a traditional 3%." },
];

export default function HowItWorksCard() {
  return (
    <div className="rounded-2xl border border-brand-hairline bg-white/80 backdrop-blur-sm p-5 sm:p-6 shadow-[0_4px_20px_rgba(11,30,140,0.04)]" data-testid="how-it-works-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <span className="eyebrow">How we got this number</span>
          <h3 className="mt-1 font-serif text-lg sm:text-xl text-brand-ink">A reconciled estimate — not a single black box</h3>
        </div>
        <Link to="/how-it-works" data-testid="how-it-works-card-link"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-emerald hover:underline shrink-0">
          See the full method <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="mt-5 grid gap-4 sm:grid-cols-3">
        {ITEMS.map((it) => (
          <div key={it.title} className="flex gap-3">
            <div className="h-9 w-9 shrink-0 rounded-lg bg-brand-emerald/10 flex items-center justify-center">
              <it.icon className="h-4.5 w-4.5 text-brand-emerald" />
            </div>
            <div>
              <p className="font-semibold text-sm text-brand-ink">{it.title}</p>
              <p className="mt-0.5 text-xs text-brand-stone leading-snug">{it.body}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
